import BaseRepository from '@/api/repositories/BaseRepository';

class UserGroupRepository extends BaseRepository {
	get endpoint() {
		return 'api/usergroup';
	}

	getByLevel(level) {
		return this.get(null, { level: level });
	}
}

export default new UserGroupRepository();
